export default __webpack_public_path__ + "static/media/QV_Skirt.150f99db.jpg";